window._mfq = window._mfq || [];
(function () {
  var mf = document.createElement('script');
  mf.type = 'text/javascript';
  mf.defer = true;
  mf.src =
    '//cdn.mouseflow.com/projects/e18ff6b2-1d32-43c9-8289-f8393c25818a.js';
  document.getElementsByTagName('head')[0].appendChild(mf);
})();
